import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DEFAULT_SLIDES = [
  {
    title: 'Simplify GST cashflow',
    subtitle: 'Upload invoices and unlock instant working capital.',
    cta: 'Explore GST loans',
    route: '/invoice-gst',
    tone: 'primary',
  },
  {
    title: 'Need a commercial vehicle?',
    subtitle: 'Check EMI options and connect with our lending partners.',
    cta: 'View CV finance',
    route: '/commercial-vehicle-loan',
    tone: 'neutral',
  },
  {
    title: 'Vendors looking for anchor finance?',
    subtitle: 'Register your supply chain and receive tailored offers.',
    cta: 'Register anchor',
    route: '/supply-chain-financing/anchor-registration',
    tone: 'accent',
  },
];

const AUTO_SCROLL_INTERVAL = 7000;

const DashboardBannerCarousel = ({ slides = DEFAULT_SLIDES, autoScroll = true, interval = AUTO_SCROLL_INTERVAL }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);
  const slidesCount = slides.length;
  const navigate = useNavigate();

  const currentSlide = useMemo(() => slides[activeIndex], [slides, activeIndex]);

  useEffect(() => {
    if (!autoScroll) return undefined;

    const start = () => {
      intervalRef.current = setInterval(() => {
        if (!isHovered) {
          setActiveIndex((prev) => (prev + 1) % slidesCount);
        }
      }, interval);
    };

    start();

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [autoScroll, slidesCount, interval, isHovered]);

  if (!slides.length) return null;

  return (
    <section
      className="dashboard-carousel"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`carousel-slide ${currentSlide.tone}`}>
        <div>
          <p className="dashboard-eyebrow">Recommended</p>
          <h3>{currentSlide.title}</h3>
          <p>{currentSlide.subtitle}</p>
          <button type="button" className="dashboard-primary-btn small" onClick={() => navigate(currentSlide.route)}>
            {currentSlide.cta}
          </button>
        </div>
      </div>
      <div className="carousel-dots">
        {slides.map((slide, index) => (
          <button
            key={slide.title}
            type="button"
            className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to slide ${slide.title}`}
          />
        ))}
      </div>
    </section>
  );
};

export default DashboardBannerCarousel;

